// @noflow
/* eslint-disable camelcase */

import { SourceType } from 'Common/models/franchise';
import { PlayerEvent } from '../../../player/utils';
import PlayerManager from '../PlayerManager';
import FreeWheelAd from '../FreeWheelAd';

export const getFreeWheelAd = (
  videoMetadata,
  responseType,
  visitorIp,
  os,
  deviceId,
  uuid,
  limitAdTracking,
  googleAdvertisingId,
) => {
  const { clipDurationSeconds, fw_guid, custom_attributes } = videoMetadata;
  const {
    mrm_site_section_id,
    freewheel_network_id,
    freewheel_profile_id,
    freewheel_server_url,
  } = custom_attributes;
  const freewheelAd = Object.assign(new FreeWheelAd(), {
    adServerUrl: freewheel_server_url,
    networkId: freewheel_network_id,
    profile: freewheel_profile_id,
    siteSection: mrm_site_section_id,
    videoAssetId: fw_guid,
    clipDurationSeconds,
    responseType,
  });

  freewheelAd.visitorIp = visitorIp;
  if (deviceId) {
    if (os === 'ios') {
      freewheelAd.deviceId = `idfa:${deviceId}`;
    } else {
      if (googleAdvertisingId) {
        freewheelAd.deviceId = `google_advertising_id:${googleAdvertisingId}`;
      }
    }
  }

  freewheelAd.uuid = uuid;
  freewheelAd.limitAdTracking = limitAdTracking;

  return freewheelAd;
};

export const getFreeWheelAdVmap = (
  videoMetadata,
  analyticsId,
  userIp,
  limitAdTracking,
  googleAdvertisingId,
) => {
  const freewheelAd = getFreeWheelAd(
    videoMetadata,
    'vmap1',
    userIp,
    null,
    null,
    analyticsId,
    limitAdTracking,
    googleAdvertisingId,
  );

  const {
    freewheel: { adSlots },
  } = videoMetadata;

  freewheelAd.adSlots = adSlots.map((slot, index) => ({
    slotId: `Slot_${index}`,
    slotPosition: slot.slotType.toLowerCase(),
    timePosition: slot.start,
  }));

  return freewheelAd;
};

export const getFreeWheelAdVast = (
  videoMetadata,
  adaptUrl,
  visitorIp,
  os,
  deviceId,
  uuid,
  limitAdTracking,
  googleAdvertisingId,
) => {
  const { freewheel: { adSlots = [] } = {} } = videoMetadata;

  const adInfo = adSlots.map((slot, index) => {
    const freewheelAd = getFreeWheelAd(
      videoMetadata,
      'vast4',
      visitorIp,
      os,
      deviceId,
      uuid,
      limitAdTracking,
      googleAdvertisingId,
    );
    freewheelAd.adSlots = [
      {
        slotId: `Slot_${index}`,
        slotPosition: slot.slotType.toLowerCase(),
        timePosition: slot.start,
      },
    ];

    return {
      adUrl: `${adaptUrl}${freewheelAd.url}`,
      adType: slot.slotType,
      timePosition: slot.start,
    };
  });

  return adInfo;
};

class OnDemandAdManager extends PlayerManager {
  constructor(playerDelegate, analyticsId, userIp, adaptUrl) {
    super(playerDelegate);
    this.analyticsId = analyticsId;
    this.userIp = userIp;
    this.adaptUrl = adaptUrl;
  }

  get enabled() {
    return !!this._videoMetadata.custom_attributes.freewheel_enabled;
  }

  get events() {
    return {
      [PlayerEvent.SourceLoaded]: () => {
        if (this.sourceType !== SourceType.ON_DEMAND) {
          return;
        }
        this.getAdSlots();
      },
    };
  }

  getAdSlots() {
    const { videoMetadata, limitAdTracking, googleAdvertisingId } = this._delegate._player.props;

    const freewheelAd = getFreeWheelAdVmap(
      videoMetadata,
      this.analyticsId,
      this.userIp,
      limitAdTracking,
      googleAdvertisingId,
    );

    const adConfig = {
      tag: {
        url: `${this.adaptUrl}${freewheelAd.url}`,
        type: 'vmap',
      },
      id: 'OnDemandAds',
    };

    this._delegate._player.playerView.ads.schedule(adConfig);
  }
}

export default OnDemandAdManager;
